import NamedDto from 'modules/base/dto/NamedDto';

export default class PiAfEventReaderEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.piConnection = null;
		/** @type {string} */
		this.database = null;
		/** @type {string} */
		this.templateName = null;
	}

	/**
	 * @typedef {Object} _PiAfEventReaderEditDtoProps
	 * @property {number} piConnection
	 * @property {string} database
	 * @property {string} templateName
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PiAfEventReaderEditDtoProps} PiAfEventReaderEditDtoProps
	 */
	/**
	 * @param {PiAfEventReaderEditDtoProps} props
	 * @returns {PiAfEventReaderEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.piConnection = props?.piConnection;
		this.database = props?.database;
		this.templateName = props?.templateName;
		return this;
	}
}
